import React from 'react'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { Section, Button } from './ui'
import { cn } from '../utils'

const CallToAction: React.FC = () => {
  return (
    <Section
      id="partner"
      background="default"
      padding="xl"
      className="relative overflow-hidden"
    >
      {/* Subtle background pattern */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className={cn(
            'absolute top-0 right-0 w-[500px] h-[500px] rounded-full',
            'bg-secondary-100/50 dark:bg-secondary-900/20',
            'blur-3xl -translate-y-1/2 translate-x-1/4'
          )}
        />
        <div
          className={cn(
            'absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full',
            'bg-primary-100/50 dark:bg-primary-900/20',
            'blur-3xl translate-y-1/2 -translate-x-1/4'
          )}
        />
      </div>

      <motion.div
        className="relative text-center max-w-3xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-50px' }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="text-xs font-medium tracking-[0.22em] uppercase text-primary-600 dark:text-primary-300 mb-4">
          Collaborate with us
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900 dark:text-white leading-tight mb-6">
          Let's build from{' '}
          <span className="text-secondary-500 dark:text-secondary-300">insight</span> to{' '}
          <span className="text-primary-500 dark:text-primary-300">impact</span>.
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed">
          MATNO is open to partnerships with institutions, researchers, innovators,
          funders, and practitioners working to advance responsible digital transformation
          in Africa.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
          <Button
            as="link"
            to="/contact#partner"
            variant="primary"
            size="lg"
            icon={<ArrowRight className="w-5 h-5" />}
          >
            Partner with MATNO
          </Button>
          <Button
            as="link"
            to="/contact"
            variant="outline"
            size="lg"
          >
            Contact us
          </Button>
        </div>
      </motion.div>
    </Section>
  )
}

export default CallToAction
